import type { SchemaField } from '@cli-types/core-engine/schema.js'
import type { FieldRenderContext } from '@cli-types/next-adapter/forms.js'
import { formItemProps } from '@next-adapter/generators/form/form-shared/form-item-props.js'
import { renderBooleanFieldRenderer } from '@next-adapter/templates/renderers/generators/form/field-jsx/render-boolean-field.js'
import { defaultValueFromSourceHandler } from './default-value-from-source-handler.js'

export function renderBooleanField(
  field: SchemaField,
  indent: string,
  label: string,
  hintJSX: string,
  context: FieldRenderContext
): string {
  const defaultValueFromHandler = defaultValueFromSourceHandler(field, context)
  const onCheckedChange = defaultValueFromHandler
    ? renderBooleanFieldRenderer({
        kind: 'renderBooleanFieldChangeHandlerTemplate',
        props: {
          indent: indent,
          defaultValueFromHandler: defaultValueFromHandler
        }
      })
    : 'formField.onChange'
  return renderBooleanFieldRenderer({
    kind: 'renderBooleanFieldFormFieldTemplate',
    props: {
      indent: indent,
      fieldName: field.name,
      formItemProps: formItemProps(field, 'flex flex-row items-start space-x-3 space-y-0'),
      onCheckedChange: onCheckedChange,
      label: label,
      hintJsxContent: hintJSX ? `\n${indent}        ${hintJSX}` : ''
    }
  })
}
